import React from 'react';

import { I18n } from 'aws-amplify';

import { Task } from '../../../utils/task';

import TextAreaField from '../../form/textarea-field';
import CheckboxField from '../../form/checkbox-field';

import constants from '../../../constants';

import { scrollToTop } from '../../../utils/ui';

class CostForm extends React.Component {
    constructor(props) {

        super(props);

        const { bPitch = {} } = props;

        this.state = {
            fields: {
                kpi: {
                    onChange: this.onChangeForm.bind(this, 'kpi'),
                    // onBlur: this.onSave.bind(this),
                    successIcon: false,
                    markAsRequired: true
                },
                deliverables: {
                    onChange: this.onChangeForm.bind(this, 'deliverables'),
                    // onBlur: this.onSave.bind(this),
                    successIcon: false,
                    markAsRequired: true
                },
            },
            errors: {},
            form: { ...bPitch },
            task: {},
            submit_task: {}
        }
    }

    componentDidMount() {
        scrollToTop();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {

        const task = this.props.task || {};
        const prev = prevProps && prevProps.task || {};

        //console.dir({ task: task, prev: prev });

        if (task != prev) {

            var nextState = Object.assign({}, prevState, { task: task });

            const { bPitch = {} } = this.props;

            Object.keys(this.state.fields).forEach((item) => {

                if (bPitch[item]) {
                    nextState.form[item] = bPitch[item];
                }

            });

            this.setState(nextState);
        }
    }

    onChangeForm(prop, e) {

        const value = e.target.value;

        this.setState((prevState) => {

            var nextState = Object.assign({}, prevState);

            nextState.form[prop] = value;
            nextState.errors[prop] = null;

            return nextState;

        }, () => this.onSaving());
    }

    onChangeFormCheckbox(prop, e) {

        const value = e.target.checked;

        this.setState((prevState) => {

            var nextState = Object.assign({}, prevState);

            nextState.form[prop] = value;
            nextState.errors[prop] = null;

            return nextState;

        }, () => this.onSaving());
    }

    getData() {

        var data = {
            projectId: this.props.match.params.projectId,
            ...this.props.bPitch,
            ...this.state.form
        };

        return data;
    }

    onSaving() {

        clearTimeout(this.t);
        this.t = setTimeout(() => this.onSave(), 1000)
    }

    onSave() {

        var submit_task = new Task();

        submit_task.start();

        this.setState({ submit_task: submit_task });

        this.props.update_bpitch(this.getData())
            .then(({ task, errors }) => {

                this.setState({ submit_task: task, errors: errors });
            });
    }

    render() {

        return (
            <div>

                <h1 className="title-bpool medium">{I18n.get("Entregáveis e KPIs")}</h1>

                <div className="bp-event-section" style={{ marginTop: '3rem', maxWidth: '40rem' }}>

                    <TextAreaField
                        {...this.state.fields.kpi}
                        label={I18n.get("Defina os KPIs de sucesso do projeto")}
                        value={this.state.form.kpi}
                        error={this.state.errors.kpi} />

                    <br />

                    <TextAreaField
                        {...this.state.fields.deliverables}
                        label={I18n.get("Cite os entregáveis dos parceiros participantes")}
                        value={this.state.form.deliverables}
                        error={this.state.errors.deliverables} />

                    <br />

                </div>
            </div>
        );
    }
}

export default CostForm;
